import styles from './NotFound.module.css';

import notFoundImg from '../../assets/images/notFound.png';
import { useAuth } from '../../hooks/useAuth';
import { HelmetComponent } from '../../components/Helmet';

export function NotFound() {
  const { client } = useAuth();

  return (
    <>
      <HelmetComponent
        clientLogoURL={client?.logoURL}
        companyName={client?.companyName}
        clientFavicon={client?.favIcon}
        primaryColor={client?.primaryColor}
        secondaryColor={client?.secondaryColor}
        tabTitle={'Não encontrada'}
      />{' '}
      <div className={styles.container}>
        <div className={styles.textWrapper}>
          <img
            src={notFoundImg}
            className={styles.notFoundImg}
            alt="not-found"
          />

          <div className="title">Ops!</div>
          <div className="title">404</div>

          <div className="subtitle">Página não encontrada</div>
        </div>
      </div>
    </>
  );
}
